import { Formik } from "formik";
import { Autocomplete, Button, MenuItem } from "@mui/material";
import CustomField from "../shared/CustomTextField";
import { useStore } from "../../hooks/store";
import Styles from "./Form.module.css";
import { useState } from "react";
import {
  postPddSubtheme,
  postPddTheme,
  updatePddTheme,
} from "../../utils/API/pddMethods";
import { postSession, updateSession } from "../../utils/API/unlimSession";
import { Add, Edit } from "@mui/icons-material";
import UserSmallGrid from "./SchoolForm/UserSmallGrid";

export default function NewSessinForm() {
  const store = useStore();
  const sessionData = store.form.dataToUpdate;
  const [userName, setUserName] = useState();
  const [initValues, setValues] = useState(
    sessionData || {
      id: "",
      device_name: "",
      user_id: "",
      session_id: null,
      code: "null",
    },
  );
  const submitSession = (values) => {
    postSession(values.user_id, values.device_name, values.code).then(
      ({ data, status }) => {
        if (status === 200) {
          store.closeForm();
          store.setAlert(data, "success");
          store.form.callBack();
          return;
        }
        store.setAlert(data.error || data, "error");
      },
    );
  };

  const submitUpdatedTheme = (values) => {
    updateSession(values.device_name, values.id).then(({ data, status }) => {
      if (status === 200) {
        store.closeForm();
        store.setAlert(data, "success");
        store.form.callBack();
        return;
      }
      store.setAlert(data.error || data, "error");
    });
  };

  const wrapperStyle = sessionData && { flexDirection: "row" };

  return (
    <Formik
      initialValues={initValues}
      onSubmit={(values, { setSubmitting }) => {
        setSubmitting(true);
        if (sessionData.id) {
          submitUpdatedTheme(values);
        } else {
          submitSession(values);
        }

        setSubmitting(false);
      }}>
      {({
        values,
        errors,
        touched,
        handleChange,
        handleBlur,
        handleSubmit,
        isSubmitting,
        handleReset,
        submitForm,
        setFieldValue,
        /* and other goodies */
      }) => (
        <>
          {console.log(values)}
          <p>
            {sessionData.id ? "Редактированние сесси" : "Привязка устройства"}
          </p>
          <form onSubmit={handleSubmit}>
            <div className={Styles.form_content} style={wrapperStyle}>
              <div className={Styles.form_fields}>
                <CustomField
                  name="device_name"
                  label="Название уст-ва"
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value={values.device_name}
                  disabled={isSubmitting}
                />
                {!sessionData.id && (
                  <>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center",
                        gap: "10px",
                      }}>
                      <Autocomplete
                        disabled={sessionData.id}
                        fullWidth
                        defaultValue={sessionData.user_id}
                        renderInput={(p) => (
                          <CustomField
                            {...p}
                            name="user_id"
                            label="Пользователь"></CustomField>
                        )}
                        disablePortal
                        options={sessionData.userList.map((u) => ({
                          id: u.id,
                          label: u.name,
                        }))}
                        getOptionKey={(o) => o.id}
                        getOptionLabel={(o) => o.label}
                        onInputChange={(e) => setUserName(e.target.value)}
                        onChange={(e, v) =>
                          setFieldValue("user_id", v.id || null)
                        }
                        // onChange={(e) => setUserId(e.target.value)}
                      />
                    </div>

                    <CustomField
                      name="code"
                      label={"Код из приложения"}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values.code}
                      disabled={sessionData.id}
                    />
                  </>
                )}
              </div>
            </div>
            <div className="form_actions">
              <Button variant="contained" onClick={handleSubmit}>
                Применить
              </Button>
            </div>
          </form>
        </>
      )}
    </Formik>
  );
}
